import { CardWrapper } from './card-wrapper';
import { WorkerExperienceItem } from './worker-experience-item';
import { useAtomValue } from 'jotai';
import { newToSectorHavingNoExperienceAtom, workerPastExperiencesAtom } from '../global-state.worker-data';
import { Alert } from '@restworld/ui-ds-base';
import { useProfileCommonIntl } from './hooks';

import { WorkerExperienceToggle } from './worker-experience-toggle';
import { cn } from '@restworld/utils-common';

export const WorkerExperiencesSection = () => {
  const { missingInfoText, welcomeToSectorText, translate } = useProfileCommonIntl();
  const hasNoExperience = useAtomValue(newToSectorHavingNoExperienceAtom);

  const workerPastExperiences = useAtomValue(workerPastExperiencesAtom);
  const itemsCount = workerPastExperiences?.length || 0;
  const alertVariant = hasNoExperience ? 'success' : 'error';
  const alertText = hasNoExperience ? welcomeToSectorText : missingInfoText;

  return (
    <CardWrapper variant="add" title={translate('common:experiences')} editPageType="work_experience">
      {(!itemsCount || hasNoExperience) && <WorkerExperienceToggle />}
      <div className="flex flex-col items-start pt-4">
        {itemsCount === 0 && <Alert text={alertText} variant={alertVariant} />}
        {workerPastExperiences?.map((workerPastExperience, index) => (
          <div className="w-full" key={index} id={`work_experience-${index}`}>
            <WorkerExperienceItem workerPastExperience={workerPastExperience} key={index} experienceIndex={index} />
            {index < itemsCount - 1 && <StyledSeparator />}
          </div>
        ))}
      </div>
    </CardWrapper>
  );
};

export const StyledSeparator = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <hr className={cn('block w-full border-t border-primary-300 h-px my-6', className)} {...props} />
);
